import ENV from '../../../environment.json'

export const APP_ENVIRONMENT: keyof typeof ENV = (process.env.VUE_APP_ENVIROMENT || 'local') as keyof typeof ENV
export const APP_SENTRY_KEY = process.env.VUE_APP_SENTRY_KEY || ''
export const APP_SENTRY_PROJECT = process.env.VUE_APP_SENTRY_PROJECT || ''

export const BASE_API_URL = ENV[APP_ENVIRONMENT].BASE_API_URL
export const BASE_API_ECOSYSTEM_URL = ENV[APP_ENVIRONMENT].BASE_API_ECOSYSTEM_URL
export const BASE_API_ONBOARDING = ENV[APP_ENVIRONMENT].BASE_API_ONBOARDING
export const BASE_URL = ENV[APP_ENVIRONMENT].BASE_URL
export const ONBOARDING_URL = ENV[APP_ENVIRONMENT].ONBOARDING_URL
export const POS_BASE_URL = ENV[APP_ENVIRONMENT].POS_BASE_URL
export const POS_ONBOARDING_URL = ENV[APP_ENVIRONMENT].POS_ONBOARDING_URL
export const PAYROLL_BASE_URL = ENV[APP_ENVIRONMENT].PAYROLL_BASE_URL
export const PAYROLL_ONBOARDING_URL = ENV[APP_ENVIRONMENT].PAYROLL_ONBOARDING_URL
export const MI_ALEGRA_URL = ENV[APP_ENVIRONMENT].MI_ALEGRA_URL
export const SUPPORT_URL = ENV[APP_ENVIRONMENT].SUPPORT_URL

export const COOKIE_AUTH = ENV[APP_ENVIRONMENT].COOKIE_AUTH
export const COOKIE_TOKEN = ENV[APP_ENVIRONMENT].COOKIE_TOKEN
export const COOKIE_USER_EMAIL = ENV[APP_ENVIRONMENT].COOKIE_USER_EMAIL
export const COOKIE_APP_VERSION = ENV[APP_ENVIRONMENT].COOKIE_APP_VERSION
export const COOKIE_LOOP = ENV[APP_ENVIRONMENT].COOKIE_LOOP
export const COOKIE_DISTRIBUTOR = ENV[APP_ENVIRONMENT].COOKIE_DISTRIBUTOR
export const COOKIE_FIRST_STEPS = ENV[APP_ENVIRONMENT].COOKIE_FIRST_STEPS

export const getEnvPrefix = () => {
  switch (APP_ENVIRONMENT) {
    case 'production':
      return 'al'
    case 'sandbox':
      return 'al-sand'
    default:
      return 'al-test'
  }
}
